import { useSearchTranslations } from '~/api/translations';
import SpinnerTw from '~/components/SpinnerTw';
import React from 'react';
import { TbFaceIdError } from 'react-icons/tb';
import { getLcn } from '~/utils/labeled-classnames';

export default function TranslationsLoadingUI({
  response,
}: {
  response: ReturnType<typeof useSearchTranslations>
}) {

  const {
    isLoading: isTranslationsLoading,
    isSuccess: isTranslationsSuccess,
    isFetched: isTranslationsFetched,
  } = response;

  if (isTranslationsLoading) {
    return (
      <div className='flex justify-center items-center'>
        <SpinnerTw />
      </div>
    )
  }

  if (isTranslationsFetched && !isTranslationsSuccess) {
    return <div><TbFaceIdError className='inline-block' /> Translations failed to load</div>
  }
}; 